export default "__VITE_ASSET__DECsDFpW__"